export type ResultsHeaderProps = {
  headerMessageType: HeaderTypes;
};

export enum HeaderTypes {
  NO_ISSUES = "NO_ISSUES",
  MISSING_DEVICES = "MISSING_DEVICES",
  FETCHING_DEVICE_INFO_MOBILE = "FETCHING_DEVICE_INFO_MOBILE",
  FETCHING_DEVICE_INFO_DESKTOP = "FETCHING_DEVICE_INFO_DESKTOP",
}
